import { render, staticRenderFns } from "./AgregarRbt.vue?vue&type=template&id=81e12b06"
import script from "./AgregarRbt.vue?vue&type=script&lang=js"
export * from "./AgregarRbt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports